import React, { memo } from 'react';
import './Filters/Filters.css';
import MultipleSelect from './MultipleSelect';
import { useCIHAFiltersContext } from './Filters/hooks/useCIHAFiltersContext';

const CityFilter = ({ className = '' }) => {
    const { filters, cities, onFilterChange } = useCIHAFiltersContext();

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            <MultipleSelect
                label="Cidade"
                options={cities}
                onChange={onFilterChange}
                name="cidade"
                className="select-cidade-dashboards"
                defaultValue={filters.cidade}
            />
        </div>
    );
};

export default memo(CityFilter);
